import type { RegionWithRequiredFields, SelectOptionType } from "../../types";

export const getRegionOptions = (regions: RegionWithRequiredFields[] = []): SelectOptionType[] => {
  return regions.map((region) => ({
    label: region.name,
    value: region.code,
  }));
};
